import { AbstractBaseUser, AbstractInstructorNumbers } from "@kvix/shared";
import { Button, Text } from "@kvix/ui";
import { Avatar, Grid, makeStyles, Paper, Theme } from "@material-ui/core";
import React from "react";
import { useTranslation } from "react-i18next";
import { useHistory } from "react-router";
import { Link } from "react-router-dom";
import { FollowButton } from "./FollowButton";

interface Props {
  instructor: AbstractBaseUser;
  /* Todo remove any for proper type */
  instructorNumbers?: AbstractInstructorNumbers;
}

const useStyles = makeStyles<Theme, Props>((theme) => ({
  root: {
    padding: theme.spacing(4),
    borderRadius: 4,

    [theme.breakpoints.down("xs")]: {
      padding: theme.spacing(3),
    },
  },
  avatar: {
    marginRight: theme.spacing(1),
    width: 120,
    height: 120,
  },
  name: {
    marginTop: theme.spacing(3),
  },
  quote: {
    paddingTop: 20,
    "&:before": {
      content: "'“'",
    },
    "&:after": {
      content: "'”'",
    },
  },
  programs: {
    paddingTop: theme.spacing(6),
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
  },
  followButton: {
    height: "24px",
    padding: "4px 8px 4px 8px;",
    fontSize: "12px",
    fontWeight: 500,
    textTransform: "none",
    letterSpacing: 0,
    borderRadius: "6px",
  },
}));

export const InstructorCard: React.FC<Props> = (props) => {
  const classes = useStyles(props);

  const history = useHistory();
  const { t, ready } = useTranslation("program");

  if (!ready) {
    return null;
  }

  return (
    <Paper className={classes.root}>
      <Grid container justify="space-between" wrap="nowrap">
        <Grid item>
          <Avatar src={props.instructor.imageUrl} className={classes.avatar} />
        </Grid>

        <Grid item>
          <FollowButton instructor={props.instructor} />
        </Grid>
      </Grid>
      <Link to={`/instructor/${props.instructor.id}`}>
        <Text
          className={classes.name}
          variant="h4"
          color="primary"
          gutterBottom
        >
          {props.instructor.name.first} {props.instructor.name.last}
        </Text>
      </Link>
      <Text>{props.instructor.instructorProfile?.title}</Text>

      {props.instructor.quote && (
        <Text className={classes.quote} variant="h4">
          {props.instructor.quote}
        </Text>
      )}

      <div className={classes.programs}>
        <Button
          fullWidth
          onClick={() => history.push(`/instructor/${props.instructor.id}`)}
        >
          {t("instructorCard.readMore")}
        </Button>
      </div>
    </Paper>
  );
};
